import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { updateArea, usePostClearCardDataMutation } from 'store/clearCard';

import type { AreaStatus } from 'types/spot';

// ClearCardを管理するためのカスタムフック
export function useClearCard() {
  const dispatch = useDispatch();
  const clearCardState = useSelector((state: RootState) => state.clearCard);
  const { area, isInitialize, areaStatus } = clearCardState;
  const [lastAreaStatus, setLastAreaStatus] = useState<AreaStatus | null>(null);

  const [postClearCardData, { isLoading: isSubmittingClearCard, error: submitClearCardError }] =
    usePostClearCardDataMutation();

  const updateAreaState = (newArea: number) => {
    dispatch(updateArea(newArea));
  };

  const postClearCard = async (area: number) => {
    try {
      const result = await postClearCardData({ area }).unwrap();
      setLastAreaStatus(result);
    } catch (error) {
      console.error('Failed to post clear-card: ', error);
    }
  };

  return {
    area,
    isInitialize,
    areaStatus,
    isSubmittingClearCard,
    submitClearCardError,
    updateAreaState,
    postClearCard,
    lastAreaStatus,
  };
}
